import TabPage from "./TabPage";

const AboutClub = () => <TabPage tabKey="aboutClub" />;

export default AboutClub;
